export default __webpack_public_path__ + "static/media/Icon_filter.ec63d235.svg";